<template>
  <form>
    
    <div class="row">
      <div class="col-lg-7">
        <h3 class="card-title">{{$t('small_technical_grants.esms_prescreening_questionnaire')}}</h3>
        <div>
        <p class="small">{{$t('small_technical_grants.esms_prescreening_questionnaire_1')}}</p>
        <div class="form-check form-check-radio form-check-inline">
          <radio name="esmsQuestionOne" inline value="true" v-model="GrantForm.revisionModel.technical.esmsQuestionOne">
            {{$t('medium_grant.general__yes')}}
          </radio>
          <radio name="esmsQuestionOne" inline value="false" v-model="GrantForm.revisionModel.technical.esmsQuestionOne">
            {{$t('medium_grant.general__no')}}
          </radio>
        </div>
        </div>

        <div>
        <p class="small">{{$t('small_technical_grants.esms_prescreening_questionnaire_2')}}</p>
        <div class="form-check form-check-radio form-check-inline">
          <radio name="esmsQuestionTwo" inline value="true" v-model="GrantForm.revisionModel.technical.esmsQuestionTwo">
            {{$t('medium_grant.general__yes')}}
          </radio>
          <radio name="esmsQuestionTwo" inline value="false" v-model="GrantForm.revisionModel.technical.esmsQuestionTwo">
            {{$t('medium_grant.general__no')}}
          </radio>
        </div>
        </div>

        <div>
        <p class="small">{{$t('small_technical_grants.esms_prescreening_questionnaire_3')}}</p>
        <div class="form-check form-check-radio form-check-inline">
          <radio name="esmsQuestionThree" inline value="true" v-model="GrantForm.revisionModel.technical.esmsQuestionThree">
            {{$t('medium_grant.general__yes')}}
          </radio>
          <radio name="esmsQuestionThree" inline value="false" v-model="GrantForm.revisionModel.technical.esmsQuestionThree">
            {{$t('medium_grant.general__no')}}
          </radio>
        </div>
        </div>

        <div>
        <p class="small">{{$t('small_technical_grants.esms_prescreening_questionnaire_4')}}</p>
        <div class="form-check form-check-radio form-check-inline">
          <radio name="esmsQuestionFour" inline value="true" v-model="GrantForm.revisionModel.technical.esmsQuestionFour">
            {{$t('medium_grant.general__yes')}}
          </radio>
          <radio name="esmsQuestionFour" inline value="false" v-model="GrantForm.revisionModel.technical.esmsQuestionFour">
            {{$t('medium_grant.general__no')}}
          </radio>
        </div>
        </div>

        <div>
        <p class="small">{{$t('small_technical_grants.esms_prescreening_questionnaire_5')}}</p>
        <div class="form-check form-check-radio form-check-inline">
          <radio name="esmsQuestionFive" inline value="true" v-model="GrantForm.revisionModel.technical.esmsQuestionFive">
            {{$t('medium_grant.general__yes')}}
          </radio>
          <radio name="esmsQuestionFive" inline value="false" v-model="GrantForm.revisionModel.technical.esmsQuestionFive">
            {{$t('medium_grant.general__no')}}
          </radio>
        </div>
        </div>

        <div>
        <p class="small">{{$t('small_technical_grants.esms_prescreening_questionnaire_6')}}</p>
        <div class="form-check form-check-radio form-check-inline">
          <radio name="esmsQuestionSix" inline value="true" v-model="GrantForm.revisionModel.technical.esmsQuestionSix">
            {{$t('medium_grant.general__yes')}}
          </radio>
          <radio name="esmsQuestionSix" inline value="false" v-model="GrantForm.revisionModel.technical.esmsQuestionSix">
            {{$t('medium_grant.general__no')}}
          </radio>
        </div>
        </div>
        <!--other projects end-->
      </div>
      
    </div>
    <div class="row mt-3">
    <div class="col-lg-8">
      <h3 class="card-title">{{$t('small_technical_grants.list_red_flag_activities')}}</h3>
      <ul>
        <li>
          {{$t('small_technical_grants.list_red_flag_activities_1')}}
        </li>
        <li>
          {{$t('small_technical_grants.list_red_flag_activities_2')}}
        </li>
        <li>
          {{$t('small_technical_grants.list_red_flag_activities_3')}}
        </li>
        <li>
          {{$t('small_technical_grants.list_red_flag_activities_4')}}
        </li>
        <li>
          {{$t('small_technical_grants.list_red_flag_activities_5')}}
        </li>
        <li>
          {{$t('small_technical_grants.list_red_flag_activities_6')}}
        </li>
        <li>
          {{$t('small_technical_grants.list_red_flag_activities_7')}}
        </li>
      </ul>
        </div>
    </div>
  </form>
</template>
<script>
  import {GrantForm} from "@/services";
  import {BaseCheckbox, BaseRadio} from 'src/components/index';
  import {EventBus} from '@/event-bus.js';

  export default {
    data() {
      return {
        GrantForm,
        orgCoApplicants: [],
        showText1: false,
        showText2: true
      }
    },
    components: {
      BaseCheckbox,
      BaseRadio
    },
    methods: {
      getError(fieldName) {
        return this.errors.first(fieldName);
      },
      addOrgCoApplicant() {
        this.orgCoApplicants.push({
          orgName: '',
          shortDesc: '',
          role: '',
          budget: ''
        })
      },
      validate() {
        return this.$validator.validateAll().then(res => {
          this.$emit('on-validated', res, this.model);
          return res;
        });
      },
      fileAdded(file) {
                //EventBus.$emit('wizard-save-progress');
      }
    },
    mounted() {
      if (GrantForm.revisionModel.technical.orgCoApplicants) {
        this.orgCoApplicants = GrantForm.revisionModel.technical.orgCoApplicants;
      }
    },
    watch: {
      orgCoApplicants(value) {
        GrantForm.revisionModel.technical.orgCoApplicants = value;
      },
    },
  }
</script>
<style lang="scss" scoped>
  a {
    color: black;

    &:hover {
      text-decoration: underline;
    }
  }

  .inline{
    display: flex;
  justify-content: space-between;
  }

  .inline p{
width: 70%;
  }
</style>
